import { useTranslation } from "@msuite/ui/localization";
import { Tag } from "@msuite/ui/tag";

/** Props Interface */
interface BankAccountDefaultCellProps {
	isDefault: boolean;
}

export function BankAccountDefaultCell({ isDefault }: BankAccountDefaultCellProps) {
	/** Context */
	const { t } = useTranslation();

	/** Guard */
	if (!isDefault) return null;

	/** Render */
	return (
		<Tag
			size="xs"
			color="emerald"
			variant="plain"
		>
			{t("contacts.bank_accounts.is_default")}
		</Tag>
	);
}
